import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useGetUserFeaturesQuery } from 'store/auth/auth.api'
import { setUserCompanyFeatures } from 'store/auth/auth.slice'
import { getUserId } from 'utils/common'
import { featuresResponseToByCompany } from 'utils/features'

/**
 * Redux only received feature flags on login. After a full refresh, `featuresByCompany`
 * was empty so WAYBILL (etc.) toggles looked off until login again. Sync from the API
 * whenever the main shell is shown and we have a session.
 */
export function AuthFeaturesSync() {
  const dispatch = useDispatch()
  const userId = getUserId()
  const hasToken = typeof window !== 'undefined' && !!window.sessionStorage.getItem('accessToken')

  const { data, isSuccess } = useGetUserFeaturesQuery(
    { userId },
    { skip: !userId || !hasToken }
  )

  useEffect(() => {
    if (!isSuccess || data === undefined) return
    dispatch(
      setUserCompanyFeatures({
        featuresByCompany: featuresResponseToByCompany(data),
      })
    )
  }, [data, dispatch, isSuccess])

  return null
}
